import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { Col, Row, Tab, Tabs } from "react-bootstrap";

const TabsNav = () => {
    const { tabKey, safariPackagesDispatch } = useSafariPackagesContext();

    return (
        <Row className="mt-4 itenary_tabs">
            <Col xl={11} lg={12} className="safartabs position-relative">
                <div className="overflow-auto w-100 hide-scrollbar">
                    <Tabs
                        id="myTab"
                        activeKey={tabKey}
                        onSelect={(key) => {
                            safariPackagesDispatch({ type: "SET_PACKAGE_VIEW_TAB_KEY", payload: key });
                        }}
                        className="nav nav-tabs slider_packagemobile d-flex gap-2 flex-nowrap"
                    >
                        <Tab
                            eventKey="overview"
                            title="Overview"
                            className="nav-item nav-link"
                        ></Tab>
                        <Tab
                            eventKey="itinerary"
                            title="Itinerary"
                            className="nav-item nav-link"
                        ></Tab>
                        <Tab
                            eventKey="inclusions"
                            title="Inclusions"
                            className="nav-item nav-link"
                        ></Tab>
                        <Tab
                            eventKey="getting-there"
                            title="Getting There"
                            className="nav-item nav-link"
                        ></Tab>
                        {/* <Tab
                        eventKey="accomodation"
                        title="Accomodation"
                        className="nav-item nav-link"
                    ></Tab> */}
                        <Tab
                            eventKey="policy-info"
                            title="T&C"
                            className="nav-item nav-link"
                        ></Tab>
                        <Tab
                            eventKey="faq"
                            title="FAQ"
                            className="nav-item nav-link"
                        ></Tab>
                    </Tabs>
                </div>
            </Col>
        </Row>
    )
}

export default TabsNav